module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/1_b1e6f7de564f4012d53aa59fc8568906.png";